import { render } from "./Tal_selectManagerList.vue?vue&type=template&id=3b3e18d4"
import script from "./Tal_selectManagerList.vue?vue&type=script&lang=js"
export * from "./Tal_selectManagerList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__